import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already consented
        const hasConsented = localStorage.getItem('cookieConsent');
        if (!hasConsented) {
            // Show banner after a short delay
            setTimeout(() => setShowBanner(true), 1000);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'false');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <Paper
            elevation={6}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                p: { xs: 2, sm: 3 },
                backgroundColor: '#1a1a1a',
                color: '#fff',
                borderRadius: 0,
            }}
        >
            <Box
                sx={{
                    maxWidth: '1200px',
                    mx: 'auto',
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        🍪 We Value Your Privacy
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#ccc' }}>
                        We use cookies to enhance your browsing experience, analyze site traffic, and provide
                        personalized content. By clicking "Accept All", you consent to our use of cookies.{' '}
                        <a
                            href="/privacy-policy"
                            style={{ color: '#facd00', textDecoration: 'underline' }}
                        >
                            Learn more
                        </a>
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        flexDirection: { xs: 'column', sm: 'row' },
                        width: { xs: '100%', md: 'auto' },
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={handleDecline}
                        sx={{
                            borderColor: '#facd00',
                            color: '#facd00',
                            '&:hover': {
                                borderColor: '#e6b800',
                                backgroundColor: 'rgba(250, 205, 0, 0.1)',
                            },
                        }}
                    >
                        Decline
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleAccept}
                        sx={{
                            backgroundColor: '#facd00',
                            color: '#000',
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: '#e6b800',
                            },
                        }}
                    >
                        Accept All
                    </Button>
                </Box>
                <IconButton
                    onClick={handleDecline}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: '#fff',
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </Paper>
    );
};

export default CookieConsent;
